/**
 * Markdown for chat messages from other people (team conversations), same rules and look as the Home chat's renderer
 * (bold, italic, code, lists, links, generated images) but the text is HTML-escaped first, so a message from another member
 * can never inject markup.
 */
const escapeHtml = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

export function renderChatMarkdown(text) {
  let s = escapeHtml(String(text ?? ''));
  s = s.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  s = s.replace(/(?<!\*)\*(?!\*)([^*]+)\*(?!\*)/g, '<em>$1</em>');
  s = s.replace(/`([^`]+)`/g, '<code style="background:var(--app-surface-3);border-radius:4px;padding:0 4px;font-family:monospace;font-size:12px">$1</code>');
  s = s.replace(/^\s*[-*]\s+(.+)$/gm, '<li style="margin-left:16px;list-style:disc;margin-bottom:2px">$1</li>');
  // Images the agent generated: only https URLs or this app's own /api/generated files.
  s = s.replace(/!\[([^\]]*)\]\(((?:https:\/\/|\/api\/generated\/)[^)\s]+)\)/g,
    '<a href="$2" target="_blank" rel="noopener noreferrer"><img src="$2" alt="$1" loading="lazy" style="display:block;max-width:100%;max-height:420px;border-radius:10px;margin:6px 0;border:1px solid var(--lyra-color-border)" /></a>');
  // Links: web URLs only (a javascript: or data: target is left as plain text).
  s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g,
    '<a href="$2" target="_blank" rel="noopener noreferrer" style="color:var(--lyra-color-primary);text-decoration:underline;cursor:pointer">$1</a>');
  return s.replace(/\n/g, '<br>');
}
